import React from "react";
import { useTranslation } from "react-i18next";

interface Props {
    price?: string;
    priceAltText?: string;
    payment?: string;
    frequencyKey?: string;
}

const Price = ({ price, priceAltText, payment, frequencyKey }: Props) => {
    const { t } = useTranslation();

    if (price === undefined && priceAltText === undefined) {
        return null;
    }

    if (price === undefined) {
        return (
            <div className={`accessories_card_price_row`}>
                <div className={`accessories_card_price_alt_text`}>{priceAltText}</div>
            </div>
        );
    }

    if (payment === undefined || frequencyKey === undefined) {
        return (
            <div className={`accessories_card_price_row`}>
                <div className={`accessories_card_payment`}>{price}</div>
            </div>
        );
    }

    return (
        <div className={`accessories_card_price_row`}>
            <div className={`accessories_card_payment`}>
                <span className={`accessories_card_payment_amount`}>{payment}</span>
                <span className={`accessories_card_payment_frequency`}>{` ${t(frequencyKey)}`}</span>
            </div>
            <div className={`accessories_card_price`}>{`${price} ${t("Accessories.total")}`}</div>
        </div>
    );
};

export default Price;
